import es from './messages/es.json'
import en from './messages/en.json'

export const messages = { es, en }
